import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import { AnalyticsService } from '../../services/analytics.service';
import './form-item-employer-value-banking.component.scss';
var FormItemEmployerValueBanking = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemEmployerValueBanking, _super);
    function FormItemEmployerValueBanking(element) {
        return _super.call(this, element) || this;
    }
    FormItemEmployerValueBanking.prototype.init = function () {
        this.form = this.element.querySelector('form');
        this.submitBtn = this.element.querySelector('.js-employer-value-banking__button');
        this.provinceSelect = this.form.querySelector('select[name=province]');
    };
    FormItemEmployerValueBanking.prototype.bindEvents = function () {
        var _this = this;
        this.submitBtn.addEventListener('click', function (event) {
            var _button = event.target;
            var _form = _button.closest('form');
            var formFields = _form.querySelectorAll('input, select');
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll(".form__group--error"));
            if (valid.length == 0) {
                _this.submitForm(_form);
            }
        });
        if (this.provinceSelect) {
            this.provinceSelect.addEventListener('change', function (event) {
                _this.selectProvinceEmail(event, _this.form);
            });
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener('blur', function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
    };
    FormItemEmployerValueBanking.prototype.selectProvinceEmail = function (event, form) {
        var provinceValue = event.currentTarget.value;
        var email = form.querySelector("input[name=email]");
        var recipient = form.querySelector("input[name=recipient]");
        //Select Email Address to send application too depending on the selected province
        var selectedProvince = provinceValue.toUpperCase();
        var provinceEmail = '';
        switch (selectedProvince) {
            case "GAUTENG": {
                provinceEmail = 'EVBGP@standardbank.co.za';
                break;
            }
            case "EASTERN CAPE": {
                provinceEmail = 'EVBEC@standardbank.co.za';
                break;
            }
            case "FREE STATE": {
                provinceEmail = 'EVBFS@standardbank.co.za';
                break;
            }
            case "KWAZULU-NATAL": {
                provinceEmail = 'evb@standardbank.co.za';
                break;
            }
            case "LIMPOPO": {
                provinceEmail = 'EVBLP@standardbank.co.za';
                break;
            }
            case "MPUMALANGA": {
                provinceEmail = 'EVBMP@standardbank.co.za';
                break;
            }
            case "NORTH WEST": {
                provinceEmail = 'EVBNW@standardbank.co.za';
                break;
            }
            case "NORTHERN CAPE": {
                provinceEmail = 'EVBNC@standardbank.co.za';
                break;
            }
            case "WESTERN CAPE": {
                provinceEmail = 'EVBWC@standardbank.co.za';
                break;
            }
            default: {
                provinceEmail = '';
                break;
            }
        }
        if (provinceEmail != '') {
            if (email) {
                email.value = provinceEmail;
            }
            if (recipient) {
                recipient.value = provinceEmail;
            }
        }
    };
    FormItemEmployerValueBanking.prototype.submitForm = function (form) {
        // success screens
        var loader = form.querySelector('.form__loader--container');
        var thankYou = form.querySelector('.form__thankyou--container');
        var fieldsContainer = form.querySelector('.form__fields--container');
        var success = form.querySelector('.form__success--container');
        var error = form.querySelector('.form__error--container');
        var postData = '';
        var serviceType = form.querySelector("input[name=serviceType]");
        if (serviceType) {
            postData += 'service-type=' + serviceType.value;
        }
        var product = form.querySelector("input[name=product]");
        if (product) {
            postData += '&product=' + product.value;
        }
        var _email = this.form.querySelector('input[name=emailAddress]');
        if (_email) {
            postData += '&emailAddress=' + _email.value;
        }
        var email = form.querySelector("input[name=email]");
        if (email) {
            postData += '&email=' + email.value;
        }
        var recipient = form.querySelector("input[name=recipient]");
        if (recipient) {
            postData += '&recipient=' + recipient.value + ',' + _email.value;
        }
        var subject = form.querySelector("input[name=subject]");
        if (subject) {
            postData += '&subject=' + subject.value;
        }
        var description = form.querySelector("input[name=description]");
        if (description) {
            postData += '&description=' + description.value;
        }
        var redirect = form.querySelector("input[name=redirect]");
        if (redirect) {
            postData += '&redirect=' + redirect.value;
        }
        var _firstName = this.form.querySelector('input[name=firstName]');
        if (_firstName) {
            postData += '&firstname=' + _firstName.value;
        }
        var _lastName = this.form.querySelector('input[name=lastName]');
        if (_lastName) {
            postData += '&surname=' + _lastName.value;
        }
        var _phoneNumber = this.form.querySelector('input[name=phoneNumber]');
        if (_phoneNumber) {
            postData += '&contactNo=' + _phoneNumber.value;
        }
        var _province = this.form.querySelector('select[name=province]');
        if (_province) {
            postData += '&province=' + _province.value;
        }
        var _cityTown = this.form.querySelector('input[name=cityTown]');
        if (_cityTown) {
            postData += '&cityTown=' + _cityTown.value;
        }
        var _isStandardBankCustomer = this.form.querySelector('select[name=isStandardBankCustomer]');
        if (_isStandardBankCustomer) {
            postData += '&existing-customer=' + _isStandardBankCustomer.value;
        }
        var _canContactCustomer = this.form.querySelector('select[name=canContactCustomer]');
        if (_canContactCustomer) {
            postData += '&canContactCustomer=' + _canContactCustomer.value;
        }
        var _interests = this.form.querySelector('textarea[name=interests]');
        if (_interests) {
            postData += '&interests=' + _interests.value;
        }
        // loader + hide form
        loader.classList.add('active');
        fieldsContainer.classList.add('hidden');
        // variables
        var analyticsService = new AnalyticsService();
        var url = this.baseUrl + "/services/genericform.jsp";
        // service
        this.formsService.postForm(url, postData).then(function (response) {
            //Always show success message / no response from server (sending email)
            analyticsService.dtmFormComplete('complete', response.code);
            loader.classList.remove('active');
            thankYou.classList.add('active');
            success.classList.add('active');
            error.classList.add('hidden');
        }).catch(function (response) {
            // service failed
            analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
            loader.classList.remove('active');
            fieldsContainer.classList.remove('hidden');
        });
    };
    return FormItemEmployerValueBanking;
}(Base));
export { FormItemEmployerValueBanking };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-employer-value-banking/form-item-employer-value-banking.component.ts
// module id = 890
// module chunks = 0